<style lang="stylus">
    .aipoint-content
        position fixed
        display flex
        justify-content center
        align-items center
        width 100vw
        height 100vh
        z-index 1001
        user-select none
        .aipoint-mask
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            background-color rgba(0,0,0,.2)
        .aipoint-box
            position relative
            width 512px
            padding-bottom 24px
            background #fff
            border-radius 8px
            z-index 1
            .bgimg
                position absolute
                left 0
                top 0
                pointer-events none
                z-index -1
            .topbar
                display flex
                justify-content space-between
                align-items center
                width 100%
                height 40px
                padding 10px 12px
                .topbar-title
                    display flex
                    align-items center
                    p
                        font-size 12px
                        color #000
                        margin-left 4px
                .topbar-close
                    cursor pointer
            .description
                display flex
                flex-wrap wrap
                justify-content center
                margin 0 24px
                p
                    width 100%
                    text-align center
                .main-text
                    font-weight 500px
                    font-size 18px
                    line-height 24px
                    margin-bottom 16px
                    color #000
                .sub-text
                    font-size 12px
                    line-height 16px
                    color #222
            .product
                width 100%
                margin 32px 24px 0 24px
                display flex
                column-gap 16px
                .product-item
                    position relative
                    display flex
                    justify-content center
                    align-items center
                    width 144px
                    height 96px
                    background #F7F8F9
                    border-radius 6px
                    &.item-en
                        justify-content center
                        >div
                            max-width 90%
                    >div
                        display flex
                        align-items center
                        >p
                            margin-left 8px
                            color #222
                            font-size 12px
                            line-height 16px
                    .product-tag
                        position absolute
                        right 0
                        top 0
                    .product-tagbox
                        position absolute
                        right 0
                        top 0
                        padding 0 8px
                        height 16px
                        background linear-gradient(92.45deg, #CBCED7 0%, #ADB3C2 100%)
                        border-radius 0px 6px
                        p
                            margin 0
                            width 100%
                            text-align center
                            font-size 10px
                            color #FFFFFF
                            font-weight 700
                            line-height 12px
                            z-index 1
            .btn-box
                display flex
                justify-content center
                column-gap 16px
                margin 32px 24px 0 24px
                height 40px
                .aipoint-btn
                    position relative
                    display flex
                    justify-content center
                    align-items center
                    border-radius 6px
                    height 40px
                    font-size 12px
                    line-height 16px
                    cursor pointer
                    user-select none
                    &.vipblue
                        width 320px
                        background var(--themeColor)
                        color #fff
                        &:hover
                            background #006adf
                    &.vip
                        width 304px
                        background: linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                        color #402300
                        font-weight 500
                        &:hover
                            background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)

                    &.blue
                        width 144px
                        background var(--themeColor)
                        color #fff
                        &:hover
                            background #006adf
                    .btn-tagbox
                        display flex
                        align-items center
                        position absolute
                        right 0
                        top -3px
                        height 20px
                        .tagbox-bg
                            position absolute
                            width 100%
                            height 100%
                            background: linear-gradient(250.56deg, #FF4B3A -23.37%, #FF974D 104.62%)
                        .tagbox-mask
                            width 100%
                            -webkit-mask: url(./assets/mask.svg) 0 no-repeat
                        .tagbox-text
                            width 100%
                            clip rect(auto, auto, auto, 13.23px)
                            border-top-right-radius 6px
                        p
                            width 100%
                            padding 0 8px 0 15px
                            margin-left 4px
                            text-align center
                            font-size 10px
                            color #FFFFFF
                            font-weight 700
                            line-height 12px
                            z-index 1
</style>

<template>
    <div class="aipoint-content">
        <div class="aipoint-mask"></div>
        <div class="aipoint-box">
            <img class="bgimg" src="./assets/bg.png" alt="" />

            <div class="topbar">
                <div class="topbar-title">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_11412_26856)">
                            <rect width="16" height="16" fill="url(#paint0_linear_11412_26856)" />
                            <path
                                d="M7.99999 8.8125H4.75C4.30127 8.8125 3.9375 8.44873 3.9375 8C3.9375 7.55127 4.30127 7.1875 4.75 7.1875H7.99999C8.44872 7.1875 8.81249 7.55127 8.81249 8C8.81249 8.44873 8.44872 8.8125 7.99999 8.8125Z"
                                fill="white"
                                fill-opacity="0.6"
                            />
                            <path
                                d="M7.99999 4.75H4.75C4.30127 4.75 3.9375 4.38623 3.9375 3.9375C3.9375 3.48877 4.30127 3.125 4.75 3.125H7.99999C10.6924 3.125 12.875 5.30761 12.875 7.99999C12.875 10.6924 10.6924 12.875 7.99999 12.875H4.75C4.30127 12.875 3.9375 12.5112 3.9375 12.0625C3.9375 11.6137 4.30127 11.25 4.75 11.25H7.99999C9.79491 11.25 11.25 9.79491 11.25 7.99999C11.25 6.20507 9.79491 4.75 7.99999 4.75Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_11412_26856"
                                x1="16.7272"
                                y1="18.6666"
                                x2="1.16582"
                                y2="-3.96816"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#0066FF" />
                                <stop offset="1" stop-color="#66CCFF" />
                            </linearGradient>
                            <clipPath id="clip0_11412_26856">
                                <rect width="16" height="16" rx="3.65049" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <p>{{ $t("titlebar") }}</p>
                </div>
                <div class="topbar-close" @click="closeModal">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="#424242" xmlns="http://www.w3.org/2000/svg">
                        <g id="app-delete" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
                            <path
                                d="M7.26178533,7.99999991 L3.15288924,3.89110382 C2.94903692,3.6872515 2.94903692,3.35674157 3.15288924,3.15288924 C3.35674157,2.94903692 3.6872515,2.94903692 3.89110382,3.15288924 L7.99999991,7.26178533 L12.108896,3.15288924 C12.3127483,2.94903692 12.6432583,2.94903692 12.8471106,3.15288924 C13.0509629,3.35674157 13.0509629,3.6872515 12.8471106,3.89110382 L8.73821449,7.99999991 L12.8471106,12.108896 C13.0509629,12.3127483 13.0509629,12.6432583 12.8471106,12.8471106 C12.6432583,13.0509629 12.3127483,13.0509629 12.108896,12.8471106 L7.99999991,8.73821449 L3.89110382,12.8471106 C3.6872515,13.0509629 3.35674157,13.0509629 3.15288924,12.8471106 C2.94903692,12.6432583 2.94903692,12.3127483 3.15288924,12.108896 L7.26178533,7.99999991 Z"
                                fill="currentColor"
                            ></path>
                        </g>
                    </svg>
                </div>
            </div>

            <div class="description">
                <img src="./assets/icon.svg" alt="" />
                <p class="main-text">{{ $t("mainText") }}</p>
                <p class="sub-text">{{ $t("subText") }}</p>
            </div>

            <div class="product">
                <div class="product-item" v-for="item in productList" :class="{ 'item-en': lang !== 'zh' }">
                    <div>
                        <img :src="item.icon" alt="" />
                        <p>{{ $t(item.label) }}</p>
                    </div>
                    <img v-if="item.type == 1" class="product-tag" src="./assets/tag-new.svg" alt="" />
                    <div v-if="item.type == 0" class="product-tagbox">
                        <p>{{ $t("tagText") }}</p>
                    </div>
                </div>
            </div>

            <div class="btn-box">
                <template v-if="vip && fuser">
                    <div
                        class="aipoint-btn vipblue"
                        :content="$t('tips1')"
                        v-tippy="{ placement: 'top', arrow: true, arrowType: 'round' }"
                        @click="toBuyPoint"
                    >
                        {{ $t("buyText") }}
                    </div>
                </template>
                <template v-else>
                    <div
                        v-if="vip"
                        class="aipoint-btn vip"
                        :content="$t('tips4')"
                        v-tippy="{ placement: 'top', arrow: true, arrowType: 'round' }"
                        @click="toVip"
                    >
                        {{ $t("upgradeVip") }}
                        <div class="btn-tagbox" v-if="showPointNum">
                            <div class="tagbox-bg tagbox-mask"></div>
                            <div class="tagbox-bg tagbox-text"></div>
                            <p>{{ pointsText }}</p>
                        </div>
                    </div>
                    <div
                        v-else
                        class="aipoint-btn vip"
                        :content="$t('tips2')"
                        v-tippy="{ placement: 'top', arrow: true, arrowType: 'round' }"
                        @click="toVip"
                    >
                        {{ $t("buyVip") }}
                        <div class="btn-tagbox" v-if="showPointNum">
                            <div class="tagbox-bg tagbox-mask"></div>
                            <div class="tagbox-bg tagbox-text"></div>
                            <p>{{ pointsText }}</p>
                        </div>
                    </div>
                    <div
                        class="aipoint-btn blue"
                        :content="$t('tips3')"
                        v-tippy="{ placement: 'top', arrow: true, arrowType: 'round' }"
                        @click="toBuyPoint"
                    >
                        {{ $t("buyText") }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component
    export default class AIpointModal extends Vue {
        productList = [
            {
                id: 0,
                icon: require("./assets/ai-icon.svg"),
                label: "aiLabel",
                type: 1,
            },
            {
                id: 1,
                icon: require("./assets/ocr-icon.svg"),
                label: "ocrLabel",
                type: 1,
            },
            {
                id: 2,
                icon: require("./assets/draw-icon.svg"),
                label: "drawLabel",
                type: 1,
            },
        ];
        showPointNum = false;
        pointNum = "648";
        get pointsText() {
            return (this.$t("vipPoints") as string).replace(/%point%/, this.pointNum);
        }
        getActivePointNum() {
            this.$edApi.getAIActivePoints().then((data) => {
                if (data) {
                    this.showPointNum = data.is_activity == 1;
                    this.pointNum = data.send_points;
                }
            });
        }
        closeModal() {
            this.$emit("closeAiModal");
        }
        toVip() {
            this.closeModal();
            this.$openBuyPage();
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get pointLink() {
            const availableLang = ["de", "fr", "es", "pt", "it", "jp"].includes(this.lang) ? `/${this.lang}` : "no";
            let host = this.internal
                ? "https://www.edrawsoft.cn/order/recharge-page.html"
                : `https://www.edrawsoft.com${availableLang}/pricing-ai-edrawmax.html`;
            if (!this.internal && availableLang == "no") {
                host = "https://edrawmax.wondershare.com/store/pricing-ai.html";
            }
            if (!this.internal && this.lang == "en") {
                // 仅en跳转固定链接
                host = "https://www.edrawmax.com/store/effects-buy.html";
            }
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.id, token: this.userInfo.token })));
            return `${host}?product=max&platform=maxonline&custom=${custom}`;
        }
        toBuyPoint() {
            this.closeModal();
            window.open(this.pointLink, "_blank");
        }
        keyEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }

        created() {
            this.getActivePointNum();
        }
        mounted() {
            document.addEventListener("keydown", this.keyEvent);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.keyEvent);
        }
    }
</script>
<i18n>
{
    "zh": {
        "titlebar": "亿图AI点数",
        "mainText": "AI点数不足",
        "subText": "您可以前往亿图账户中心购买AI点数，AI点数可以在亿图旗下所有软件中使用",
        "aiLabel": "AI智能助手",
        "ocrLabel": "OCR图片文字提取",
        "drawLabel": "AI绘画",
        "tagText": "敬请期待",
        "buyText": "购买AI点数",
        "buyVip": "开通会员",
        "upgradeVip": "补差价升级终身会员",
        "vipPoints": "限时赠送%point%点数",
        "tips1": "点数可用于AI相关功能的使用",
        "tips2": "开通会员即可赠送AI点数",
        "tips3": "充值点数仅支持使用亿图AI相关功能，如需使用会员付费功能，需开通会员。",
        "tips4": "补差价即可赠送AI点数"
    },
    "en": {
        "titlebar": "EdrawMax AI points",
        "mainText": "Insufficient AI points",
        "subText": "Go to EdrawMax Account Center to purchase AI points, which can be used in all EdrawMax software.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR Image Text Extraction",
        "drawLabel": "AI drawing",
        "tagText": "Stay tuned",
        "buyText": "Purchase AI points",
        "buyVip": "Upgrade to Premium",
        "upgradeVip": "Upgrade to a lifetime plan",
        "vipPoints": "%point% free points for a limited time only",
        "tips1": "Points can be used for the use of AI-related functions",
        "tips2": "Upgrade to Premium to get AI points",
        "tips3": "AI points can only be used for EdrawMax AI features. If you wish to use paid membership features, you must upgrade your membership.",
        "tips4": "Pay a little extra amount and get AI points"
    },
    "de": {
        "titlebar": "EdrawMax AI-Punkte",
        "mainText": "Unzureichende AI-Punkte",
        "subText": "Besuchen Sie das EdrawMax Konto-Center, um AI-Punkte zu erwerben, die in allen EdrawMax-Programmen verwendet werden können.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR Image Text Extraction",
        "drawLabel": "AI-Zeichnung",
        "tagText": "Bleiben Sie auf dem Laufenden",
        "buyText": "AI-Punkte erwerben",
        "buyVip": "Steigen Sie auf Premium um",
        "upgradeVip": "Auf ein unbegrenztes Abonnement upgraden",
        "vipPoints": "Nur für begrenzte Zeit: %point% kostenlose Punkte",
        "tips1": "Punkte können für die Nutzung von KI-bezogenen Funktionen verwendet werden",
        "tips2": "Steigen Sie auf Premium um, um AI-Punkte zu erhalten",
        "tips3": "AI-Punkte können nur für EdrawMax AI-Funktionen verwendet werden. Wenn Sie die Funktionen der kostenpflichtigen Mitgliedschaft nutzen möchten, müssen Sie Ihre Mitgliedschaft upgraden.",
        "tips4": "Für einen kleinen Aufpreis erhalten Sie AI-Punkte "
    },
    "es": {
        "titlebar": "Puntos de IA de EdrawMax",
        "mainText": "Puntos de IA insuficientes",
        "subText": "Vaya al Centro de cuentas de EdrawMax para comprar puntos de IA, que se pueden utilizar en todo el software de EdrawMax.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR Image Text Extraction",
        "drawLabel": "Dibujos con IA",
        "tagText": "Mantenerse al día",
        "buyText": "Comprar puntos de IA",
        "buyVip": "Actualice a Premium",
        "upgradeVip": "Actualice a un plan vitalicio",
        "vipPoints": "%point% puntos gratuitos solo durante un tiempo limitado",
        "tips1": "Los puntos se pueden utilizar para utilizar funciones relacionadas con la IA",
        "tips2": "Actualice a Premium para obtener puntos de IA",
        "tips3": "Los puntos de IA solo se pueden utilizar para las funciones de IA de EdrawMax. Si desea utilizar las funciones de la suscripción de pago, debe actualizar su suscripción.",
        "tips4": "Pague un poco más y obtenga puntos de IA"
    },
    "fr": {
        "titlebar": "Points IA EdrawMax",
        "mainText": "Points IA insuffisants",
        "subText": "Accédez au centre de compte EdrawMax pour acheter des points IA, qui peuvent être utilisés dans tous les logiciels EdrawMax.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR Image Text Extraction",
        "drawLabel": "Dessin IA",
        "tagText": "Restez à l'écoute",
        "buyText": "Acheter des points IA",
        "buyVip": "Passer à la version Premium",
        "upgradeVip": "Passer à une offre illimitée",
        "vipPoints": "%point% points gratuits pendant une durée limitée",
        "tips1": "Les points peuvent être utilisés pour des fonctions liées à l’IA.",
        "tips2": "Passez à la version Premium pour obtenir des points IA",
        "tips3": "Les points IA ne peuvent être utilisés que pour les fonctionnalités d’IA d’EdrawMax. Si vous souhaitez utiliser les fonctionnalités payantes, vous devez mettre à niveau votre abonnement.",
        "tips4": "Payez un peu plus et obtenez des points IA"
    },
    "id": {
        "titlebar": "Poin AI EdrawMax",
        "mainText": "Poin AI tidak cukup",
        "subText": "Buka Pusat Akun EdrawMax untuk membeli poin AI yang dapat digunakan di semua perangkat lunak EdrawMax.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR Image Text Extraction",
        "drawLabel": "Gambar AI",
        "tagText": "Pantau terus",
        "buyText": "Beli poin AI",
        "buyVip": "Tingkatkan ke Premium",
        "upgradeVip": "Tingkatkan ke paket seumur hidup",
        "vipPoints": "%point% poin gratis dengan waktu terbatas",
        "tips1": "Poin dapat digunakan untuk fungsi terkait AI",
        "tips2": "Tingkatkan ke Premium dan dapatkan poin AI",
        "tips3": "Poin AI hanya dapat digunakan untuk fitur AI EdrawMax. Tingkatkan keanggotaan Anda untuk menggunakan fitur keanggotaan berbayar.",
        "tips4": "Bayar lebih dan dapatkan poin AI"
    },
    "it": {
        "titlebar": "Punti AI EdrawMax",
        "mainText": "Punti AI insufficienti",
        "subText": "Accedi a Centro account EdrawMax per acquistare punti AI che possono essere utilizzati in tutti i software EdrawMax.",
        "aiLabel": "Assistente AI",
        "ocrLabel": "Estrazione del testo da immagine OCR",
        "drawLabel": "Disegno AI",
        "tagText": "Resta in attesa",
        "buyText": "Acquista punti AI",
        "buyVip": "Passa a Premium",
        "upgradeVip": "Passa a un piano a vita",
        "vipPoints": "%point% punti gratuiti solo per un periodo limitato",
        "tips1": "I punti possono essere utilizzati per l'uso di funzioni correlate all'AI",
        "tips2": "Passa a Premium per ottenere punti AI",
        "tips3": "I punti AI possono essere utilizzati solo per le funzioni AI di EdrawMax. Se desideri utilizzare le funzionalità a pagamento, sarà necessario aggiornare l'iscrizione.",
        "tips4": "Ottieni punti AI pagando un piccolo extra"
    },
    "jp": {
        "titlebar": "EdrawMax AIポイント",
        "mainText": "AIポイントが不足しています",
        "subText": "EdrawMaxアカウントセンターでAIポイントを購入してください。購入したポイントは、すべてのEdrawMaxソフトウェアで使用できます。",
        "aiLabel": "AIアシスタント",
        "ocrLabel": "OCR画像テキスト抽出",
        "drawLabel": "AI描画",
        "tagText": "お待ちください",
        "buyText": "AIポイントを購入",
        "buyVip": "プレミアムにアップグレード",
        "upgradeVip": "ライフタイムプランにアップグレード",
        "vipPoints": "期間限定で%point%ポイント無料進呈",
        "tips1": "ポイントはAI関連の機能に使用できます",
        "tips2": "プレミアムにアップグレードしてAIポイントを獲得",
        "tips3": "AIポイントはEdrawMax AI機能にのみ使用できます。有料メンバーシップの機能を使用する場合は、メンバーシップをアップグレードする必要があります。",
        "tips4": "少しの追加料金でAIポイントを獲得できます"
    },
    "kr": {
        "titlebar": "EdrawMax AI 포인트",
        "mainText": "AI 포인트 부족",
        "subText": "모든 EdrawMax 소프트웨어에서 사용할 수 있는 AI 포인트를 구매하려면 EdrawMax 계정 센터로 이동하세요.",
        "aiLabel": "AI Assistant",
        "ocrLabel": "OCR 이미지 텍스트 추출",
        "drawLabel": "AI 드로잉",
        "tagText": "접속 유지",
        "buyText": "AI 포인트 구매",
        "buyVip": "프리미엄으로 업그레이드하기",
        "upgradeVip": "평생 플랜으로 업그레이드",
        "vipPoints": "%point% 무료 포인트 기간 한정",
        "tips1": "AI 관련 기능 사용 시 포인트 사용 가능",
        "tips2": "프리미엄으로 업그레이드하여 AI 포인트 받기",
        "tips3": "AI 포인트는 EdrawMax AI 기능에만 사용할 수 있습니다. 유료 멤버십 기능을 사용하려면 멤버십을 업그레이드해야 합니다.",
        "tips4": "추가 금액 결제하고 AI 포인트 받기"
    },
    "pt": {
        "titlebar": "Pontos de IA do EdrawMax",
        "mainText": "Pontos de IA insuficientes",
        "subText": "Acesse o Centro de contas do EdrawMax para comprar pontos de IA, que podem ser usados em todos os softwares do EdrawMax.",
        "aiLabel": "Assistente com IA",
        "ocrLabel": "Extração de texto de imagem por OCR",
        "drawLabel": "Desenho da IA",
        "tagText": "Fique ligado",
        "buyText": "Comprar pontos de IA",
        "buyVip": "Fazer upgrade para Premium",
        "upgradeVip": "Faça upgrade para um plano vitalício",
        "vipPoints": "%point% pontos grátis somente por tempo limitado",
        "tips1": "Os pontos podem ser utilizados para o uso de funções relacionadas à IA",
        "tips2": "Faça upgrade para Premium para obter pontos de IA",
        "tips3": "Os pontos de IA só podem ser usados para recursos de IA do EdrawMax. Se desejar usar os recursos da assinatura paga, faça o upgrade da sua assinatura.",
        "tips4": "Pague um pouco mais e ganhe pontos de IA"
    },
    "tw": {
        "titlebar": "EdrawMax AI 點數",
        "mainText": "AI 點數不足",
        "subText": "前往 EdrawMax 帳戶中心購買 AI 點數，點數可用於所有 EdrawMax 軟體。",
        "aiLabel": "AI 助理",
        "ocrLabel": "OCR 影像文字擷取",
        "drawLabel": "AI 繪圖",
        "tagText": "敬請期待",
        "buyText": "購買 AI 點數",
        "buyVip": "升級至 Premium",
        "upgradeVip": "升級至終身方案",
        "vipPoints": "%point% 個限時免費點數",
        "tips1": "點數可用於 AI 相關功能",
        "tips2": "升級至 Premium 即可獲得 AI 點數",
        "tips3": "AI 點數僅可用於 EdrawMax AI 功能。如果您想使用付費會員功能，必須先升級會員資格。",
        "tips4": "只需再支付少許金額，即可獲得 AI 點數"
    }
}
</i18n>
